import { defaultAxios } from '@/services';

const stampedService = {
  async createStampedInfo(
    api_key: string,
    api_secret: string,
    store_hash: string,
    workspaceAlias: string,
  ) {
    try {
      const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/stamped/credential`,
        {
          api_key,
          api_secret,
          store_hash,
        },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async getStampedInfo(alias: string) {
    try {
      const res = await defaultAxios.get(`/workspaces/${alias}/stamped/`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async importWorkspaceFeedback(
    alias: string,
    startDate: string,
    endDate: string,
  ) {
    try {
      const res = await defaultAxios.post(`/stamped/${alias}/import`, {
        start_date: startDate,
        end_date: endDate,
      });
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async deleteStampedInfo(alias: string) {
    try {
      const res = await defaultAxios.delete(`/stamped/${alias}`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
};

export default stampedService;
